import Button from '@sats-group/ui-lib/react/button';
import LinkButton from '@sats-group/ui-lib/react/link-button';
import Modal from '@sats-group/ui-lib/react/modal';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import BackgroundImage from '../background-image/background-image';
import ContentContainer from '../content-container/content-container';
import RichText from '../rich-text/rich-text';
import type { BootCampEventHero as Props } from './boot-camp-event-hero.types';

const BootCampEventHero: React.FC<Props> = ({
  actionRef,
  brand,
  footnote,
  image,
  info,
  signup,
  terms,
  title,
}) => (
  <div className="boot-camp-event-hero">
    <ContentContainer theme={ContentContainer.themes.wide} raw>
      <div className="boot-camp-event-hero__inner">
        <div
          className={`boot-camp-event-hero__details boot-camp-event-hero__details--${brand}`}
        >
          <Text
            elementName="h1"
            size={Text.sizes.headline1}
            theme={Text.themes.headline}
            italic
          >
            {title}
          </Text>

          <div className="boot-camp-event-hero__info">
            {info.map(item => (
              <div key={item.value} className="boot-camp-event-hero__info-item">
                <Text
                  elementName="span"
                  className="boot-camp-event-hero__info-label"
                >
                  {item.text}
                </Text>
                <Text elementName="span" theme={Text.themes.emphasis}>
                  {item.value}
                </Text>
              </div>
            ))}
          </div>

          <div>
            <div className="boot-camp-event-hero__action" ref={actionRef}>
              <LinkButton {...signup} variant={Button.variants.cta} wide />
            </div>

            <div className="boot-camp-event-hero__footnote">
              <Text
                size={Text.sizes.small}
                className="boot-camp-event-hero__footnote-info"
                elementName="p"
              >
                {footnote}
              </Text>
              {terms ? (
                <div className="boot-camp-event-hero__terms">
                  <button
                    className="boot-camp-event-hero__terms-button"
                    type="button"
                    popoverTarget={terms.modal.id}
                  >
                    {terms.label}
                  </button>
                  <Modal {...terms.modal}>
                    <RichText {...terms.text} />
                  </Modal>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        {image ? (
          <div className="boot-camp-event-hero__image">
            <BackgroundImage {...image} />
          </div>
        ) : null}
      </div>
    </ContentContainer>
  </div>
);

export default BootCampEventHero;
